<template>
  <div class="detail_header">
    <div class="detail_header_content">
      <div class="home" @click="gotoHome"><i class="fa fa-home"></i></div>
      <div class="title">华夏游学X三见客</div>
      <div class="personal" @click="gotoProfile"><i class="fa fa-user-o"></i></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'my-header',
  props: {
  },
  methods: {
    gotoHome () {
      this.$router.push('/')
    },
    gotoProfile () {
      this.$router.push('/user/profile')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  @import "@/assets/css/mixin.scss";

  .detail_header {
    width: 100%;
    height: rem(70);
  }
  .detail_header_content {
    max-width: 640px;
    position: fixed;
    z-index: 998;
    top: 0;
    background-color: #ff9500;
    box-sizing: border-box;
    width: 100%;
    height: rem(70);
    padding: rem(10) 3%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    .home {
      font-size: rem(36);
    }
    .title {
      font-size: rem(31);
    }
    .personal {
      font-size: rem(32);
    }
  }
</style>
